import { create } from "zustand";
import { persist } from "zustand/middleware";

import type { Admin } from "@/api/admins";

export type AdminStoreState = {
  admin: Admin | null;
  token: string | null;
  setAdmin: (admin: Admin | null) => void;
  setToken: (token: string | null) => void;
  clearAdmin: () => void;
};

export const useAdminStore = create<AdminStoreState>()(
  persist(
    (set) => {
      return {
        admin: null,
        token: null,

        setAdmin: (admin: Admin | null) => {
          set({ admin });
        },
        setToken: (token: string | null) => {
          set({ token });
        },
        clearAdmin: () => {
          set({ admin: null, token: null });
        },
      };
    },
    { name: "useAdminStore" },
  ),
);

export const getAdminStoreState = () => {
  return useAdminStore.getState();
};
